import * as React from 'react';
import { connect } from 'react-redux';

import { changeChannel } from '../actions/channels';

import {
    getBaseUrl,
    getClientId,
} from '../reducers/config';

import {
    getActiveChannelId,
} from '../reducers/gui';

import {
    getMatchIdByChannelId,
    getPhaseIdByChannelId,
} from '../reducers/timings';

import {
    getPeriodScoresByMatchId,
    getRankingsByMatchId,
    getTeamNamesByMatchId,
    getServingPlayerByMatchId,
    getGamePointsByMatchId,
    getGameScoreByMatchId,
    getPlayerIdsByMatchId,
    getPlayerUidsByMatchId,
    getPeriodByMatchId,
    getTeamAbbreviationNamesByMatchId,
} from '../reducers/matches';

import {
    getRankAccordingToPlayerId,
} from '../reducers/statsRanking';

import {
    getStaticText, 
} from "../reducers/staticTexts";

import { getTranslations } from "../reducers/translations";

import LiveScorePresentation from '../presentations/LiveScore/LiveScorePresentation';

let logFlag: boolean = false;
let logFlagGame: boolean = false;

const mapStateToProps = (state: any, ownProps: { channelId?: number }) => {
    const activeChannelId: number = getActiveChannelId(state);
    const activePhaseId = getPhaseIdByChannelId(state, activeChannelId);
    const channelId: number = ownProps.channelId ? ownProps.channelId : activeChannelId;
    const matchId = getMatchIdByChannelId(state, channelId);
    const active: boolean = ownProps.channelId ? ownProps.channelId === activeChannelId : true;
    const gameScore = getGameScoreByMatchId(state, matchId);
    const gamePoints = getGamePointsByMatchId(state, matchId)
    const playerAbbreviationNames = getTeamAbbreviationNamesByMatchId(state, matchId);
    const servingPlayer = getServingPlayerByMatchId(state, matchId)

    const translations:any = {
        'Game point': 'VideoLiveScore_pointflag_gamepoint',
        'Set point': 'VideoLiveScore_pointflag_setpoint',
        'Break point': 'VideoLiveScore_pointflag_breakpoint',
        'Match point': 'VideoLiveScore_pointflag_matchpoint',
        '_': 'VideoLiveScore_pointflag_point',
        '_Game': 'VideoLiveScore_pointflag_game',
        '_Set': 'VideoLiveScore_pointflag_set',
        '_Break': 'VideoLiveScore_pointflag_break',
        '_Match': 'VideoLiveScore_pointflag_matchvictory'
    }

    const gamePointsBefore = {
        'home': gamePoints.last_game_points ? gamePoints.last_game_points.home : null,
        'away': gamePoints.last_game_points ? gamePoints.last_game_points.away : null
    }

    let pointflagStaticTextKey:string = null
    let pointflagSuffix:string = null
    let competitor:string = null

    // PHASE_BETSTOP, PHASE_RALLY
    if((activePhaseId==4 || activePhaseId==5)) { 
        pointflagStaticTextKey = translations[gameScore.pointflag]
        switch(gameScore.pointflag) { 
            case 'Game point':
                competitor = servingPlayer
                break
            case 'Break point':
                competitor = servingPlayer=='home' ? 'away' : 'home'
                break
            case 'Set point':
            case 'Match point':
                competitor = gameScore.team
                break
        }
        pointflagSuffix = playerAbbreviationNames[competitor]
    // PHASE_POST_POINT, PHASE_POST_MATCH
    }else if((activePhaseId==6 || activePhaseId==8)) { 
        pointflagStaticTextKey = translations['_'+gameScore.pointflag]
        switch(gameScore.pointflag) {
            case '':
                competitor = gameScore.team
                break
            case 'Game':
            case 'Break':
            case 'Set':
                competitor = gameScore.team
                break
            case 'Match':
                competitor = gameScore.team
                break                            
        }
        pointflagSuffix = playerAbbreviationNames[competitor]
    }

    return {
        baseUrl: getBaseUrl(state),
        clientid: getClientId(state),
        activeChannelId: activeChannelId,
        activePhaseId: activePhaseId,
        periodScores: getPeriodScoresByMatchId(state, matchId),
        ranks: getRankingsByMatchId(state, matchId),
        ranksByPlayerIds: getRankAccordingToPlayerId(state),
        playerNames: getTeamNamesByMatchId(state, matchId),
        playerAbbreviationNames: playerAbbreviationNames,
        servingPlayer: servingPlayer,
        gamePoints: gamePoints,
        gameScore: gameScore,
        pointflagStaticTextKey: pointflagStaticTextKey,
        pointflagSuffix: pointflagSuffix,
        playerids: getPlayerIdsByMatchId(state, matchId),
        playerUids: getPlayerUidsByMatchId(state, matchId),
        period: getPeriodByMatchId(state, matchId),
        active: active,
        staticTexts: getStaticText(state),
        translations: getTranslations(state)
    };

};

const mapDispatchToProps = (dispatch: Function) => ({
    changeChannel: (id: any) => dispatch(changeChannel(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LiveScorePresentation);
